import React, { HTMLAttributes } from "react";
import BoardCell from "@/components/board-cell";
import Loader from "@/components/loader";
import { cn } from "@/helpers/classNames";

export const BOARD_ROWS = 6;
export const BOARD_COLS = 22;

interface BoardProps extends HTMLAttributes<HTMLDivElement> {
  message: Array<string[]> | null;
}

const getCharacter = (message: BoardProps["message"], index: number) => {
  const row = Math.floor(index / BOARD_COLS);
  const column = index % BOARD_COLS;

  if (!message || !message[row] || !message[row][column]) {
    return null;
  }

  return message[row][column];
};

const Board: React.FC<BoardProps> = ({ message, ...props }) => (
  <div className="relative">
    <div
      className={cn(
        "grid bg-black/35 p-1 shadow-xl rounded gap-px text-base/none *:w-[0.875em] *:bg-black/65 *:aspect-[3/5] *:rounded-sm *:font-medium *:flex *:items-center *:justify-center *:text-center sm:*:w-[1.05em] sm:text-base-fluid/none sm:gap-0.5",
        message === null ? "animate-pulse" : undefined,
      )}
      style={{
        gridTemplateRows: `repeat(${BOARD_ROWS}, minmax(0, 1fr))`,
        gridTemplateColumns: `repeat(${BOARD_COLS}, minmax(0, 1fr))`,
      }}
      {...props}
    >
      {Array.from({ length: BOARD_ROWS * BOARD_COLS }, (_, index) => (
        <BoardCell key={index} value={getCharacter(message, index)} />
      ))}
    </div>
    {message === null && (
      <div className="absolute inset-0 flex items-center justify-center">
        <Loader className="size-6" />
      </div>
    )}
  </div>
);

export default Board;
